module.exports = __webpack_public_path__ + "static/fonts/Fact-Thin.b00b9d8.woff2";